import React from "react";
import "@tableau/embedding-api";

const TableauVisualize = ({ link, token, filters }) => {
  return (
    <div style={{ height: "auto", width: "100%" }}>
      <tableau-viz
        src={link}
        token={token}
        toolbar="bottom"
        height="80vh"
        width="100%"
        hide-tabs={true}
      >
        {filters &&
          filters.length > 0 &&
          filters.map((filter, i) => (
            <viz-filter key={i} field={filter.key} value={filter.value} />
          ))}
      </tableau-viz>
    </div>
  );
};

export default TableauVisualize;
